import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { routeTo } from 'transfer/utils/routeHelper'
import glamorous from 'glamorous'
import { mediaQueries } from 'transfer/styles'

import * as UnifiedActions from 'transfer/actions/unified-actions'
import * as ViewActions from 'transfer/actions/Actions'
import { changeThemeId } from 'transfer/actions/theme'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from 'transfer/utils/unified-send-analytics'
import content from 'pp-react-l10n'
import { HeadingText } from '@paypalcorp/pp-react'
import FriendsAndFamilyCard from './friends-and-family-card'
import GoodsAndServicesCard from './goods-and-services-card'
import { paymentTypeUrlMap } from './index'
import { getFlowType } from '../../../utils/url-utils'
import { redirectToDolphin } from '../../../actions/unified-actions'
import { handleInterstitialCipFlow } from '../../../utils/homeInfoUtils'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { getDefaultPaymentType } from 'transfer/components/unified/payment-type-choice/helpers'
import { PAYMENT_TYPE } from '../../../../../../lib/constants'

const i18nPaymentType = content('transfer/inc/paymentTypeChoices')
const { phoneLandscapeMax: mobile } = mediaQueries

const Title = glamorous.h2({
  marginTop: 0,
})

export class PaymentTypeChoice extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    flowType: PropTypes.string,
    handleClose: PropTypes.func,
    handleCloseForOtherFlow: PropTypes.func,
    isGuest: PropTypes.bool,
    isPurchase: PropTypes.bool,
    hasSelectedFundingOption: PropTypes.bool,
    themeId: PropTypes.string,
    giftOption: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        giftOption: PropTypes.string,
      }),
    ]),
    triggerSenderPhoneConfirmation: PropTypes.bool,
    amount: PropTypes.any,
    currencyCode: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    displayName: PropTypes.string,
    recipient: PropTypes.string,
    payerId: PropTypes.string,
    paymentTypeIsSelected: PropTypes.bool,
    isPersonalDisabled: PropTypes.bool,
    isPurchaseDisabled: PropTypes.bool,
    highlightPaymentType: PropTypes.string,
  }

  url = null
  targetFlowType = null

  // we route on unmount because if we route immediately after dispatching the action to close the overpanel,
  // it's too fast and the overpanel stays attached to the DOM.. so we let the overpanel unmounting do the routing
  componentWillUnmount() {
    const {
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      payerId,
      recipient,
      displayName,
      thumbnailUrl,
    } = this.props

    if (
      this.props.flowType !== 'payRequest' &&
      triggerSenderPhoneConfirmation
    ) {
      const flowType = this.targetFlowType || this.props.flowType
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      this.props.dispatch(redirectToDolphin(data))
    } else if (this.url && this.url !== 'payRequest') {
      routeTo(this.url)
    }
  }

  handleCloseForOtherFlow = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (!this.props.paymentTypeIsSelected || preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      shouldUpdateTransactionData = true
      this.targetFlowType = targetFlowType
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === 'send' ? 'guestSelectFF' : 'guestSelectGS'
      } else {
        pageAction = targetFlowType === 'send' ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)

      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === 'buy',
          changedPurchaseProtection: true,
        })
      )
      if (this.props.isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }
    }

    this.props.handleCloseForOtherFlow(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  handleClick = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.isPersonalDisabled && targetFlowType === 'send') {
      return handleInterstitialCipFlow(targetFlowType)
    }
    if (this.props.isPurchaseDisabled && targetFlowType === 'buy') {
      return handleInterstitialCipFlow(targetFlowType)
    }

    // the handleClose is closely coupled to send flow
    // this is hack for other flows so that we do not need to do the routing
    if (this.props.handleCloseForOtherFlow) {
      return this.handleCloseForOtherFlow(targetFlowType)
    }

    const url =
      this.props.flowType !== 'payRequest'
        ? paymentTypeUrlMap[targetFlowType]
        : 'payRequest'

    if (this.props.flowType === 'payRequest') {
      const preFlowType = this.props.isPurchase ? 'buy' : 'send'
      if (!this.props.paymentTypeIsSelected || preFlowType !== targetFlowType) {
        shouldUpdateTransactionData = true
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      this.url = url
      this.targetFlowType = targetFlowType
      shouldUpdateTransactionData = true
      const pageAction = targetFlowType === 'send' ? 'selectFF' : 'selectGS'
      trackClickUnifiedSend(pageAction)
      // purely for instrumentation
      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === 'buy',
          changedPurchaseProtection: true,
        })
      )
    }
    const { themeId, giftOption } = this.props
    if (targetFlowType === 'buy' && themeId && giftOption) {
      this.props.dispatch(changeThemeId(''))
      this.props.dispatch(ViewActions.changeGiftOption(''))
    }
    this.props.dispatch(ViewActions.setPaymentTypeSelected(true))
    this.props.handleClose(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  render() {
    const { flowType, isPurchase, highlightPaymentType } = this.props

    const PaymentTypes = glamorous.div({
      margin: '8% auto',
      display: 'grid',
      gridAutoRows: '1fr',
      gridRowGap: isDw2Repaint() ? '10px' : '50px',
      [mobile]: {
        margin: '8%',
      },
    })

    const selectedPaymentType = getDefaultPaymentType({
      flowType,
      isPurchase,
      defaultPaymentType: highlightPaymentType,
    })
    const isFriendsAndFamilySelected =
      selectedPaymentType === PAYMENT_TYPE.PERSONAL
    const isGoodsAndServicesSelected =
      selectedPaymentType === PAYMENT_TYPE.PURCHASE

    return (
      <div>
        {isDw2Repaint() ? (
          <HeadingText as={Title} size="sm" className="txtCenter">
            {i18nPaymentType('main.title')}
          </HeadingText>
        ) : (
          <h2 className="txtCenter ppvx_text--xl3">
            {i18nPaymentType('main.title')}
          </h2>
        )}
        <PaymentTypes
          tabIndex="-1"
          css={{
            ':focus': {
              outline: 'none',
            },
          }}
        >
          <FriendsAndFamilyCard
            selected={isFriendsAndFamilySelected}
            handleClick={this.handleClick.bind(this, 'send')}
          />
          <GoodsAndServicesCard
            selected={isGoodsAndServicesSelected}
            handleClick={this.handleClick.bind(this, 'buy')}
          />
        </PaymentTypes>
      </div>
    )
  }
}

export default connect(({ server, user, recipient, amount, transaction }) => ({
  flowType: getFlowType(),
  triggerSenderPhoneConfirmation:
    server.triggerSenderPhoneConfirmation ||
    user.triggerSenderPhoneConfirmation,
  displayName: recipient.displayName,
  thumbnailUrl: recipient.thumbnailUrl,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  recipient: recipient.recipient,
  payerId: recipient.payerId,
  isPurchase: transaction.isPurchase,
  paymentTypeIsSelected: transaction.paymentTypeIsSelected,
  isPersonalDisabled: user.isPersonalDisabled,
  isPurchaseDisabled: user.isPurchaseDisabled,
  highlightPaymentType: recipient.highlightPaymentType,
}))(PaymentTypeChoice)
